import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const SuccessColors = createInteractiveColorVars('success');
const SuccessColorsLightValues = Object.freeze({
    base: {
        default: '#158423',
        action: '#0E5A18',
        active: '#158423',
        activeAction: '#0E5A18',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const SuccessColorsDarkValues = Object.freeze({
    base: {
        default: '#64ED68',
        action: '#45A349',
        active: '#64ED68',
        activeAction: '#45A349',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});

export { SuccessColors, SuccessColorsDarkValues, SuccessColorsLightValues };
